import { createContext } from 'react'

const IncidentManegementContext = createContext()

export default IncidentManegementContext
